import * as _ from 'lodash'
import { GetterTree } from 'vuex'
import { RootState } from '@/store/types'
import { ProductState } from '@/modules/product/store'
import ProductTranslation from '@/modules/product/model/ProductTranslation';

const getters: GetterTree<ProductState, RootState> = {

    /**
     * Permite obtener la traducción actualmente seleccionada por el usuario
     */
    currentTranslation: (state) => {
        const locale = state.currentLocale

        return state.currentProduct.translate(locale) || new ProductTranslation(locale)
    },
}

export default getters
